import React, { useState } from "react";
import Modal from "../common/Modal";
import { InfoIcon } from "../../icons";


export const DisclaimerContent = () => {
	return(
		<div>
			<div className="text-center font-lexendSemibold p-4 md:p-5 text-xl md:text-[32px] text-secondary-500 border-b border-b-light-600">Disclaimer</div>
			<div className="text-center py-4 px-4 md:px-5 text-sm  text-secondary-400">Compensation may impact where the Sponsored Schools appear on our website, including the order in which they appear in a listing. Our website does not provide, nor is it intended to provide, a comprehensive list of all schools (a) in the United States, (b) located in a specific geographic area, or (c) that offer a particular program of study. By providing information or agreeing to be contacted by a Sponsored School, you are in no way obligated to apply to or enroll with the school.</div>
		</div>
	)
}

const HeaderMessage = () => {

	const [isDisclaimer, setIsDisclaimer] = useState(false);

	function onCloseHandler(){
		setIsDisclaimer(false);
	}

    return (
		<div className="flex items-center justify-center md:py-3 py-2 md:px-0 px-4 font-lexendlight text-sm md:leading-[23px] text-dark-500 font-light md:text-center border-b-[1px] border-b-light-600">
			<span className="mr-[10px]">This site receives compensation, which can influence the order and appearance of listings</span>
			<button className="mt-[2px] self-start" onClick={() => setIsDisclaimer(true)}><InfoIcon/></button>

			{isDisclaimer && (
				<Modal onClose={onCloseHandler} modalClass="max-w-[600px]" modalBodyClass="rounded-lg border border-[#213F72]">
					<DisclaimerContent />
				</Modal>
			)}
		</div>
	);
};

export default HeaderMessage;
